import React from "react";
import { Outlet } from "react-router-dom";

const AreaRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default AreaRoot;
